import { FrequencyUnit, Timestamp } from '@griply/types';
import { addDays, isSameDay } from 'date-fns';

export enum SlotLabelKind {
  Today = 'today',
  Tomorrow = 'tomorrow',
  WeekdayShort = 'weekday-short',
  WeekdayWithDate = 'weekday-with-date',
}

export type SlotLabelMode =
  | { kind: SlotLabelKind.Today }
  | { kind: SlotLabelKind.Tomorrow }
  | { kind: SlotLabelKind.WeekdayShort; date: Timestamp }
  | { kind: SlotLabelKind.WeekdayWithDate; date: Timestamp };

export type GetSlotLabelModeOptions = {
  today: Timestamp;
  frequencyUnit?: FrequencyUnit;
};

/**
 * Returns the display mode for a single day within an UpcomingPeriod slot.
 * - Today / Tomorrow get their own modes (translatable labels).
 * - Monthly/yearly schedules get a weekday + date format, since the week context is lost.
 * - Weekly schedules get an abbreviated weekday label.
 */
export const getSlotLabelMode = (
  date: Timestamp,
  { today, frequencyUnit }: GetSlotLabelModeOptions,
): SlotLabelMode => {
  if (isSameDay(date, today)) {
    return { kind: SlotLabelKind.Today };
  }
  if (isSameDay(date, addDays(today, 1))) {
    return { kind: SlotLabelKind.Tomorrow };
  }
  if (
    frequencyUnit === FrequencyUnit.Month ||
    frequencyUnit === FrequencyUnit.Year
  ) {
    return { kind: SlotLabelKind.WeekdayWithDate, date };
  }
  return { kind: SlotLabelKind.WeekdayShort, date };
};
